import {ButtonGroup, Button} from "@progress/kendo-react-buttons"
import {setPlannerInterval} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"

const timeIntervals = [
    {
        name: "15 Mins",
        value: 15,
    },
    {
        name: "30 Mins",
        value: 30,
    },
    {
        name: "45 Mins",
        value: 45,
    },
    {
        name: "1 Hr",
        value: 60,
    },
]

const PlannerIntervalBtnGroup = () => {
    //selector for Interval
    const dispatch = useAppDispatch()
    const plannerInterval = useAppSelector((state: RootState) => state.containers.motBooking.plannerInterval)

    const changePlannerInterval = (value: number) => {
        dispatch(setPlannerInterval(value))
    }

    return (
        <ButtonGroup className="shadow-none float-end">
            {timeIntervals.map((item, index) => {
                return (
                    <Button
                        className="btn-grey"
                        togglable={true}
                        onClick={() => changePlannerInterval(item.value)}
                        selected={item.value === plannerInterval}
                        key={`plannerIntevalBtn_${index}`}
                        type="button"
                    >
                        {item.name}
                    </Button>
                )
            })}
        </ButtonGroup>
    )
}

export default PlannerIntervalBtnGroup
